import { render, staticRenderFns } from "./DisplayModeSwitch.vue?vue&type=template&id=47928eef&scoped=true"
import script from "./DisplayModeSwitch.vue?vue&type=script&lang=js"
export * from "./DisplayModeSwitch.vue?vue&type=script&lang=js"
import style0 from "./DisplayModeSwitch.vue?vue&type=style&index=0&id=47928eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47928eef",
  null
  
)

export default component.exports